import { List, fromJS } from 'immutable';
import { BAR, COLUMN } from 'reporting-data/constants/chartTypes';
import { AGGREGATION, TIME_SERIES } from 'reporting-data/constants/configTypes';
import * as MetricTypes from 'reporting-data/constants/metricTypes';
import * as PROCESSOR_TYPES from 'reporting-data/constants/processorTypes';
import { DESC } from 'reporting-data/constants/sortOrder';
import { logError } from 'reporting-data/monitoring/logger';
//@ts-expect-error Untyped import
import { isMismatchedDimensionDateFilterPropertyTimeSeries } from 'reporting-data/properties/isMismatchedDimensionDateFilterPropertyTimeSeries';
import { getDateRangeFilterValue, getDimensions, getReportConfig, getReportProcessors } from 'reporting-data/report/configReportGetters';
import { setProcessorType } from 'reporting-data/report/configReportSetters';
import { getFilterGroupsByConfigName } from 'reporting-data/report/multiConfigReportGetters';
import { setDimensions as setMultiConfigDimensions, setFilterGroupsByConfigName } from 'reporting-data/report/multiConfigReportSetters';
import { getCustomWidgetType } from 'reporting-data/report/reportGetters';
import { isMultiConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { fromMetricKey } from 'reporting-data/v2/dataset/datasetMetrics';
//@ts-expect-error Untyped import
import Widgets from 'reporting-ui-components/components/customWidgets/constants/widgets';
//@ts-expect-error Untyped import
import getDefaultFrequency from 'reporting-ui-components/lib/getDefaultFrequency';
import { getGoalReportConfigName, updateGoalFilterGroupsForDimension, getReportIsSubAppWithGoals } from '../DimensionEditor/subAppDimensionUtils';
import { getReportWithValidRangeAndFrequency } from '../common/dateRangeHelpers';
import { canBeComparisonConfig } from './comparisonHelpers';
const getSort = metric => {
  const {
    property,
    metricTypes
  } = metric;
  return [{
    property,
    metricType: metricTypes && metricTypes.length > 0 ? metricTypes[0] : MetricTypes.SUM,
    order: DESC
  }];
};
export const updateMetrics = (report, metrics) => {
  const populatedMetrics = metrics.map(metric => {
    const {
      property,
      type
    } = fromMetricKey(metric);
    return {
      property,
      metricTypes: [type]
    };
  });
  const sortMetric = populatedMetrics[0];
  return report.setIn(['config', 'metrics'], fromJS(populatedMetrics)).setIn(['config', 'sort'], fromJS(getSort(sortMetric)));
};
const isCompareValid = report => canBeComparisonConfig(report) && !isMismatchedDimensionDateFilterPropertyTimeSeries(report);
export const updateDimensions = (report, dimensionNames, isTimeSeries) => {
  const dateRange = getDateRangeFilterValue(getReportConfig(report));
  let defaultFrequency;
  try {
    defaultFrequency = getDefaultFrequency(dateRange.toJS());
  } catch (ex) {
    logError({
      error: new Error('Error getting default frequency', {
        cause: ex
      }),
      extra: {
        report
      }
    });
  }
  let updatedReport = report.setIn(['config', 'dimensions'], fromJS(dimensionNames)).setIn(['config', 'configType'], isTimeSeries ? TIME_SERIES : AGGREGATION).updateIn(['config', 'frequency'], currentFrequency => {
    if (isTimeSeries) {
      return currentFrequency || defaultFrequency;
    }
    return null;
  }).update('chartType', chartType => getCustomWidgetType(report) === Widgets.SALES_QUOTA ? isTimeSeries ? COLUMN : BAR : chartType);
  if (isMultiConfigReport(report)) {
    updatedReport = setMultiConfigDimensions(updatedReport, getDimensions(report), List(dimensionNames));
  }
  const goalReportConfigName = getGoalReportConfigName(updatedReport);
  if (getReportIsSubAppWithGoals(report) && goalReportConfigName) {
    const reportAsMultiConfigReport = updatedReport;
    const currentGoalFilterGroups = getFilterGroupsByConfigName(reportAsMultiConfigReport, goalReportConfigName);
    const updatedGoalFilterGroups = updateGoalFilterGroupsForDimension(currentGoalFilterGroups, dimensionNames[0]);
    updatedReport = setFilterGroupsByConfigName(reportAsMultiConfigReport, goalReportConfigName, updatedGoalFilterGroups);
  }
  if (!isTimeSeries) {
    if (getReportProcessors(report).contains(PROCESSOR_TYPES.ACCUMULATE)) {
      // Toggle Cumulative OFF for aggregation reports
      updatedReport = setProcessorType(updatedReport, PROCESSOR_TYPES.ACCUMULATE);
    }
  }
  const withCorrectedDateFields = getReportWithValidRangeAndFrequency(updatedReport);
  return withCorrectedDateFields.updateIn(['config', 'compare'], currentCompare => isCompareValid(withCorrectedDateFields) ? currentCompare : null);
};